import { useTranslation } from "react-i18next";

import { FloatingLabelSelect, Skeleton } from "@aviary";
import { useAccountTypesQuery } from "@shared/data/queries/AccountTypesQuery/AccountTypes.query";
import { e2eAttributes } from "@shared/e2eAttributes";
import { useStripeAdditionalInfo } from "@shared/hooks/useStripeAdditionalInfo/useStripeAdditionalInfo";
import { l } from "@shared/locales/i18n";
import { BusinessTypes } from "@shared/types/fields/businessTypes";

import type { FieldProps } from "../types";

const BusinessTypeSelect = ({ value, errors, onChange, disabled, disabledValues }: FieldProps) => {
  const { t } = useTranslation();
  const stripeAdditionalInfoEnabled = useStripeAdditionalInfo();

  const { data: accountTypesData, loading: accountTypesLoading } = useAccountTypesQuery();

  if (accountTypesLoading) {
    return <Skeleton type="typography" typographySize="body" />;
  }

  const isOptionDisabled = (optionValue: string) => {
    return disabledValues?.includes(optionValue);
  };

  const filteredAccountTypes =
    stripeAdditionalInfoEnabled && !disabled
      ? accountTypesData?.viewer?.accountTypes?.filter?.(
          type => type.value !== BusinessTypes.SOLEPROPRIETOR
        )
      : accountTypesData?.viewer?.accountTypes;

  return (
    <FloatingLabelSelect
      data-testid="business-type-select"
      id="businessType"
      name={t(l.sharedSettings.tax.legalInfo.businessType)}
      label={t(l.sharedSettings.tax.legalInfo.businessType)}
      handleChange={onChange}
      value={value}
      required
      errors={errors}
      disabled={disabled}
      data-e2e={e2eAttributes.paymentSettings.businessType}
    >
      <option value="" key="" disabled>
        {t(l.sharedCommon.Select)}
      </option>
      {filteredAccountTypes?.map?.(type => {
        return (
          <option key={type.value} value={type.value} disabled={isOptionDisabled(type.value)}>
            {type.presentation}
          </option>
        );
      })}
    </FloatingLabelSelect>
  );
};

export { BusinessTypeSelect };
